module.exports = __webpack_public_path__ + "media/images/emblems/Lyssach-coat_of_arms-15d0d29d593807742bbf802082750e81.svg";